import { MAX_PAGE_SIZE_DEFAULT } from '~/constants/srp';
import type { ConditionalTile, Vehicle } from '~/contracts/srp';

export default function injectConditionalTiles<V extends Vehicle>(
  vehicles: V[],
  conditionalTiles: ConditionalTile[]
): Array<ConditionalTile | V> {
  const activeConditionalTiles = conditionalTiles.filter(v => v.active);
  const pageSize = MAX_PAGE_SIZE_DEFAULT - activeConditionalTiles.length;
  const tiles: Array<ConditionalTile | V> =
    vehicles.length > pageSize
      ? [...vehicles].slice(0, vehicles.length - activeConditionalTiles.length)
      : [...vehicles];

  activeConditionalTiles.forEach(tile => {
    if (tile.index === -1) {
      tiles.push(tile);
    } else {
      tiles.splice(tile.index, 0, tile);
    }
  });

  return tiles;
}
